<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-select  v-model="dataForm.userId" filterable clearable placeholder="资金方">
            <el-option v-for="item in  fundList" :key="item.userId" :value="item.userId" :label="item.deptName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="充值开始日期"
                    end-placeholder="充值结束日期"
                     :default-time="['00:00:00','23:59:59']"
                     value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.type" filterable clearable placeholder="类型">
            <el-option v-for="item in  typeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" filterable clearable placeholder="状态">
            <el-option v-for="item in  statusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="btn">
            <el-button @click="getDataList('dept')">{{ $t("query") }}</el-button>
            <el-button v-if="$hasPermission('system:financial_details:save')" type="primary" @click="addOrUpdateHandle()">
              <div class="add_records">
                <img src="../../../assets/img/add.svg" alt="">
                <span>记录</span>
              </div>
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        style="width: 100%"
        border
    >
      <el-table-column prop="userName" label="资金方" header-align="center" align="center"></el-table-column>
      <el-table-column prop="payType" label="类型" header-align="center" align="center"></el-table-column>
      <el-table-column prop="accrual" label="发生额" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.accrual != null">{{'￥'+ Number(scope.row.accrual).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableBalance" label="可用余额" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.availableBalance != null">{{'￥'+ Number(scope.row.availableBalance).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="keyboarderName" label="录入员" header-align="center" align="center"></el-table-column>
      <el-table-column prop="inputTime" label="录入时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="checkerName" label="复核员" header-align="center" align="center"></el-table-column>
      <el-table-column prop="checkerTime" label="复核时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="status" label="状态" header-align="center" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 'TAKE_EFFECT'"> 生效 </span>
          <span v-else-if="scope.row.status == 'RE_CHECK_REFUSE'"> 复核拒绝 </span>
          <span v-else-if="scope.row.status == 'AWAIT_RE_CHECK'"> 待复核 </span>
        </template>
      </el-table-column>
      <el-table-column prop="certificateUrl" label="充值凭证" header-align="center" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.certificateUrl != ''" class="blue" @click="lookUpCertificate(scope.row.certificateUrl)">查看</span>
        </template>
      </el-table-column>
      <el-table-column prop="operate" label="操作" header-align="center" align="center" width="160px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == 'AWAIT_RE_CHECK' && $hasPermission('system:financial_details:review')" class="ope_btn" type="primary" plain size="small" @click="addOrUpdateHandle(scope.row.id,'review')">复核</el-button>
          <el-button v-if="scope.row.status == 'RE_CHECK_REFUSE' && $hasPermission('system:financial_details:update')" class="ope_btn" type="primary" plain size="small" @click="addOrUpdateHandle(scope.row.id,'update')">修改</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
      <el-dialog
        :visible.sync="cerVisible"
        width="40%"
      >
        <img  width="100%" :src="cerUrl" alt="">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="downloadUrl(cerUrl)">下载</el-button>
          <el-button  @click="cerVisible = false">关闭</el-button>
        </span>
      </el-dialog>
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './pretopup-add-or-update.vue'
export default {
  mixins: [mixinViewModule],
  components:{
    AddOrUpdate
  },
  data() {
    return {
      cerUrl:'',
      cerVisible:false,
      date:null,
      fundList:[],
      typeList:[],
      statusList:[],
      
      mixinViewModuleOptions: {
        getDataListURL: `/system/financial_details/pageList`,
        getDataListIsPage: true,
        multilist:true,

      },
    } 
  },
  created(){
    this.$http.get('/sys/user/queryUserIdList').then(res=>{
        this.fundList = res.data.data
    })
    this.$http.get(`/sys/dict/data/list?dataType=pay_type`).then(r=>{
      this.typeList = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
      this.typeList = this.typeList.filter(item => item.value != '消费')
    })
    this.$http.get(`/sys/dict/data/list?dataType=re-check`).then(r=>{
      this.statusList = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
  },
  methods:{
    lookUpCertificate(url){
      if(url == '') {
        return this.$http.error('暂无凭证')
      }
      this.cerUrl = url
      this.cerVisible = true
    },
    // 下载凭证
    downloadUrl(url){
      
      window.location.href = url
      
    },
    getTimes() {
        if (this.date != null) {
          this.dataForm.startTime = this.date[0]
          this.dataForm.endTime = this.date[1]
          console.log(33,this.dataForm);
        }else{
          this.dataForm.startTime =''
          this.dataForm.endTime = ''
        }
    },
  }
}
</script>
<style scoped lang="scss">
.btn{
  display: flex;
  align-items: center;
}
  .add_records{
    display: flex;
    align-items: center;
    img{
      width: 12px;
      margin-right: 4px;
    }
  }
  .ope_btn{
    padding: 5px 10px;
  }
.blue {
  color: blue;
  cursor: pointer;
}
</style>